var render = function render(){var _vm=this,_c=_vm._self._c;return _c('company-layout',[_c('v-container',{attrs:{"fluid":""}},[_c('app-media-manager',{attrs:{"prefix":"/api/media-manager/"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }